export const empty = input => {
  if (Array.isArray(input)) {
    return input.length == 0;
  }
  if (
    typeof input === "undefined" ||
    input === null ||
    input === "" ||
    input === 0 ||
    input === false
  ) {
    return true;
  }
  return false;
};

export const isValidPhoneNumber = input => {
  let phoneRegex = /(?:^61[23478]\d{8})$|(?:^0?[23478]\d{8}$)|(?:^[1-9]\d{7}$)/;
  return phoneRegex.test(input);
};
export const isValidContactName = input => {
  let invalidCharactersRegex = /[^0-9a-zA-Z' ._-]+/;
  let atLeastOneChar = /[a-zA-Z]+/;
  return !invalidCharactersRegex.test(input) && atLeastOneChar.test(input);
};
export const initPopover = () => {
  $('[data-toggle="popover"]:not([data-init])').each(function () {
    let $this = $(this);

    if ($this.data("init") === "1") return;

    let content = "";
    if ($this.data("content")) {
      content = $this.data("content");
    } else if ($this.data("popoverContent")) {
      content = $($this.data("popoverContent")).html();
    }
    let template =
      '<div class="popover csn-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';

    let options = {
      container: "body",
      content: content,
      template: template,
      trigger: "focus"
    };

    $this.popover(options);
    $this.data("init", 1);
  });
};

export const initTooltip = () => {
  if ($.fn.tooltip) {
    $('[data-toggle="tooltip"]').each(function () {
      let $this = $(this);
      let option = {
        html: false,
        title: $this.attr('title')
      };
      if ($this.data('target')) {
        option.html = $this.data('html');
        option.title = option.html
          ? $($this.data('target')).html()
          : $($this.data('target')).text();
      }
      $this.tooltip(option);
    });
  }
};

export const sendGAEvent = (category, label, action) => {
  if (
    typeof GAEventTracker !== "undefined" &&
    typeof GAEventTracker.sendEvent === "function"
  ) {
    GAEventTracker.sendEvent(undefined, category, label, action);
  } else {
    console.log(
      "No ga tracking handler to fire for category: " +
      category +
      ", label: " +
      label +
      ", action: " +
      action
    );
  }
};

export const waitFor = (stopCondition, interval, retry) => {
  return new Promise((resolve, reject) => {
    if (retry < 1) {
      reject("Number of retry exeeded");
    }
    else {
      if (stopCondition()) {
        resolve();
      }
      else {
        window.setTimeout(() => {
          waitFor(stopCondition, interval, retry - 1)
            .then(success => resolve(), failure => reject(failure));
        }, interval)
      }
    }
  })
};

export const times = n => f => {
  let iter = i => {
    if (i === n) return;
    f(i);
    iter(i + 1);
  }
  return iter(0);
}

export const isValidPostcode = postcode => {
    const australianPostcodeRegex = /^((0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2}))*$/;
    return australianPostcodeRegex.test(postcode);
}

export const onceOnly = (action, waitDuration, uniqueKey) => {
  if (window[uniqueKey] !== undefined) {
    clearTimeout(window[uniqueKey]);
  }
  window[uniqueKey] = setTimeout(action, waitDuration);
}